export default __webpack_public_path__ + "static/media/b2b.3997da5f.svg";